import { render, staticRenderFns } from "./FootDouble1430.vue?vue&type=template&id=8477c644"
import script from "./FootDouble1430.vue?vue&type=script&lang=js"
export * from "./FootDouble1430.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports